import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"

const CustomReactBootstrapSlider = (props) => {
    const { tooltip, change, handleChange, slideStop, disabled, min, max, step, value } = props;
    const mySliderRef = useRef(null)
    const nodeRef = useRef(null)
    const changeRef = useRef(change || handleChange);
    const slideStopRef = useRef(slideStop);

    useEffect(() => {
        changeRef.current = change || handleChange;
    }, [change, handleChange]);

    useEffect(() => {
        slideStopRef.current = slideStop;
    }, [slideStop]);

    useEffect(() => {
		const sliderAttributes = {
            ...props,
            tooltip: tooltip || "show",
        }

        mySliderRef.current = new Slider(nodeRef.current, sliderAttributes)

        mySliderRef.current.on("change", e => {
            const fakeEvent = { target: { value: e.newValue } };
            if (changeRef.current) changeRef.current(fakeEvent);
        });

        mySliderRef.current.on("slideStop", e => {
            const fakeEvent = { target: { value: e } };
            if (slideStopRef.current) slideStopRef.current(fakeEvent);
        });

        checkAndDoDisabled()

		return () => {
			mySliderRef.current.destroy()
		}
	}, [])

    useEffect(() => {
        updateSliderValues()
    })

    const checkAndDoDisabled = () => {
        const sliderEnable = disabled !== "disabled"
        const currentlyEnabled = mySliderRef.current.isEnabled()
        if (sliderEnable) {
            if (!currentlyEnabled) {
                mySliderRef.current.enable()
            }
        } else {
            if (currentlyEnabled) {
                mySliderRef.current.disable()
            }
        }
    }

    const updateSliderValues = () => {
        if (
            typeof min !== "undefined" &&
            (typeof mySliderRef.current.min !== "undefined" ||
                typeof mySliderRef.current.options.min !== "undefined")
        ) {
            mySliderRef.current.setAttribute("min", min);
        }
        if (
            typeof max !== "undefined" &&
            (typeof mySliderRef.current.max !== "undefined" ||
                typeof mySliderRef.current.options.max !== "undefined")
        ) {
            mySliderRef.current.setAttribute("max", max);
        }
        if (
            typeof step !== "undefined" &&
            (typeof mySliderRef.current.step !== "undefined" ||
                typeof mySliderRef.current.options.step !== "undefined")
        ) {
            mySliderRef.current.setAttribute("step", step);
        }

        mySliderRef.current.setValue(value)
        checkAndDoDisabled()
    }

    return <div ref={nodeRef} />
}

CustomReactBootstrapSlider.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.arrayOf(PropTypes.number.isRequired).isRequired
    ]).isRequired,
    disabled: PropTypes.string,
    tooltip: PropTypes.string,
    change: PropTypes.func,
    handleChange: PropTypes.func,
    slideStop: PropTypes.func,
    labelledby: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ])
};

export default CustomReactBootstrapSlider;
